import { DocumentLibDto, EntityMetaDto } from "@app/api";
import { CerFormPaneType, CerFormPaneVisible, CerFormPanesSettingsUtil, uiCmdPaneRightToggle } from "./cer-form-panes/cer-form-panes.service";
import { CerFormView } from "./cer-form-view";
import { CerFormViewSet } from "./cer-form-view-set";
import { CerFormRouteOptions } from "./cer-form-route-options";
import { CerFormContext } from "./cer-form-context";
import { CerSessionService } from "@cer/cer-session/cer-session.service";
import { DocumentLibFinderViews } from "@core/document-lib/document-lib-finder.form";
import { UiCommand } from "@cer/cer-ui/cer-ui-types";

const cerDataLinkTypeNames = ['finder', 'attachment', 'note', 'log'] as const;
export type CerDataLinkType = typeof cerDataLinkTypeNames[number];

//  Form Views
type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};
export type CerFormViewDataLinksSetup = PartialRecord<CerDataLinkType, CerFormViewDataLinkTypeSetup>;

export class CerFormViewDataLinkTypeSetup {
  public pane?: CerFormPaneType;
  public enabled?: boolean;
  public visible?: boolean;
}

export function cerFormViewDataLinkDefaultSetup(type: CerDataLinkType): CerFormViewDataLinkTypeSetup {
  return cerFormViewDataLinkTypesDefaultSetup[type];
}

export const cerFormViewDataLinkTypesDefaultSetup: Record<CerDataLinkType, CerFormViewDataLinkTypeSetup> =
{
  finder: {},
  attachment: {},
  note: {},
  log: {}
}

export class CerFormViewDataLinkConnector {

  private context: CerFormContext;
  private session: CerSessionService;
  private routeOptions: CerFormRouteOptions
  private entityName: string;
  private entity: EntityMetaDto;
  private uiCmdDetailToggle: UiCommand = Object.assign({}, uiCmdPaneRightToggle, { text: 'Vedhæftninger', tooltipText: 'Vis/luk tilknyttet information [Ctrl]+[Pil venste]', toolbarShowTextOn: 'Both' });

  constructor(private viewSet: CerFormViewSet, private parentView: CerFormView) {
    this.routeOptions = parentView.routeOptions;
    this.context = this.routeOptions?.context;
    this.session = this.context?.session;
    this.entityName = this.parentView?.viewMetadata?.dataApiName;
    if (this.session?.user != null) {
      this.entity = this.session.user.entityByName(this.entityName);
      this.session.user.documentLibs$.subscribe(libs => this.onDocumentLibs(libs));
      this.session.user.entities$.subscribe(entities => this.onUserEntities(entities));
    }
  }

  private docLibs: DocumentLibDto[];
  private userEntities: EntityMetaDto[];

  public init() {

  }

  private onDocumentLibs(libs: DocumentLibDto[]) {
    this.docLibs = libs;
  }

  private onUserEntities(entities: EntityMetaDto[]) {
    this.userEntities = entities;
  }

  public dataLinkViewsAdd() {
    if (this.entity == null) {
      return;
    }
    if (this.attachmentViewsAdd(this.parentView.dataLink?.attachment)) {
      this.parentView.toolbarCommands ??= [];
      this.parentView.toolbarCommands.push(this.uiCmdDetailToggle);
    };

  }

  public attachmentViewsAdd(linkSetup: CerFormViewDataLinkTypeSetup): boolean {
    if (linkSetup?.enabled == false) {
      return false;
    }
    const docLib = this.docLibGet(this.entityName);
    if (docLib == null) {
      return false;
    }
    var paneAdded = false;
    const views = DocumentLibFinderViews.get(docLib, this.routeOptions.context, this.parentView);
    if (views.finderView) {
      const v = views.finderView;
      const p = linkSetup?.pane ?? 'right';
      v.mandatory = true;
      this.viewSet.panes ??= CerFormPanesSettingsUtil.main('horizontal',false);
      const panes = this.viewSet.panes;
      if (!panes[p]) {
        panes[p] = {
          visible: (linkSetup?.visible == true ? 'show' : 'collapse') as CerFormPaneVisible,
          size: '30%',
        };
        if (p == 'right' && panes.main != null && panes.main.size == null) {
          panes.main.size == '70%';
        }
        paneAdded = true;
      }
      panes[p].sizeSecondary ??= '20%';
      
      v.visibleDefault = panes[p].visible;
      v.paneTarget = p;
      
      this.viewSet.add(v, this.parentView);
    }
    if (views.attachmentView) {
      const v = views.attachmentView;
      const p = linkSetup?.pane ?? 'bottomRight';
      v.mandatory = true;
      if (!this.viewSet.panes[p]) {
        this.viewSet.panes[p] = {
          visible: 'show' as CerFormPaneVisible
        };
        paneAdded = true;
      }
      this.viewSet.panes[p].sizeSecondary ??= '80%';
      
      v.visibleDefault = this.viewSet.panes[p].visible;
      v.paneTarget = p;
      
      this.viewSet.add(v, views.finderView ? views.finderView : this.parentView);
    }
    return paneAdded;
  }

  public docLibGet(entityName: string): DocumentLibDto {
    var entity = this.userEntities?.find(e => e.name == entityName);
    if (entity?.dataLink?.documentLib == null) {
      return null;
    }
    return this.docLibs?.find(l => l.id == entity.dataLink.documentLib);
  }
}